import { React, useState } from "react";
import Header from "../../Components/Header";
import SideBar from "../../Components/SideBar";
import { BallerzToken, BallerzRedirect } from "../../Client/Ballerz.js";
import { useGetRequest } from "../../Client/index.js";
import SkillCard from "../../Components/SkillCard";
import MobileDropdown from "../../Components/MobileDropdown";
import AllTimeCard from "./AllTimeCard.js";
import MobileFooter from "../../Components/MobileFooter";

export default function SkillzoneAllTime() {
  let ballerzToken = BallerzToken();

  if (!ballerzToken) {
    BallerzRedirect();
  }

  const { status, data } = useGetRequest("skillzone-all", {});

  if (status === "fetched") {
    return (
      <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
        <Header title={"skillzone"} username={data?.username} />

        <div className="flex flex-1">
          <SideBar usernames={data?.visits[0]?.username} />

          <main className="flex-1 p-4 sm:p-6">
            <div className="grid gap-4">
              <div className="block sm:hidden">
                <MobileDropdown />
              </div>

              {data.visits?.length === 0 && (
                <div className="w-full md:w-1/2">
                <a
                  href="https://ballerz.co.uk/book-now/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={require("../../Assets/Images/NoSkillzone.png")}
                    alt="No results"
                    draggable={false}
                    className="w-[95%] h-auto mx-auto"
                  />
                </a>
                </div>
              )}

              {data?.visits?.map((allTime, index) => (
                <AllTimeCard allTime={allTime} />
              ))}

              <div className="block sm:hidden">
                <MobileFooter />
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
